module.exports = __webpack_public_path__ + "static/media/2019_conf_The_Engineering_Lead.b240a316.png";